import { useEffect, useState } from "react";

import { getAppBuildInfo } from "@/config/build-info";
import { runningAsApp } from "@/lib/runningAsApp";

const CHECK_EVERY_MS = 30 * 60 * 1000;

/**
 * The installed app can stay open for days. This only offers the new version: the page never
 * reloads by itself, so nothing changes under someone in the middle of a scene.
 */
export function AppUpdatePrompt() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const current = getAppBuildInfo().gitSha;
    if (!import.meta.env.PROD || !runningAsApp() || current === "unknown") {
      return;
    }
    const check = (): void => {
      void fetch("/version.json", { cache: "no-store" })
        .then((response) => response.json() as Promise<{ gitSha?: string }>)
        .then(({ gitSha }) => {
          if (gitSha !== undefined && gitSha !== current) {
            setReady(true);
          }
        })
        .catch(() => undefined);
    };
    const onVisible = (): void => {
      if (document.visibilityState === "visible") {
        check();
      }
    };
    check();
    document.addEventListener("visibilitychange", onVisible);
    const timer = setInterval(check, CHECK_EVERY_MS);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      clearInterval(timer);
    };
  }, []);

  return ready ? (
    <button type="button" className="app-update" onClick={() => window.location.reload()}>
      New version available. Tap to refresh
    </button>
  ) : null;
}
